import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getCustomerContacts } from '../../customers'

export default function useCustomerContacts(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(['customerContacts', query], () =>
    getCustomerContacts(query)
  )
  return { data, error, isLoading }
}
